/* src/app/workshop-defects/partials/workshop-defect-form/workshop-defect-form.component.scss */
.sourceBadge {
  display: inline-block;
  margin-bottom: 1rem;
  padding: 0.4rem 0.75rem;
  border-radius: 0.25rem;
  background: rgba(249, 148, 32, 0.12);
  color: #e07f0e;
  font-size: 0.85rem;
  font-weight: 600;
}
.sourceBadge i {
  margin-right: 0.35rem;
}
/*# sourceMappingURL=workshop-defect-form.component.css.map */
